export default function MushinLogo({ size = 'default', shadow = false, className = '' }) {
  const h = size === 'large' ? 'h-16' : 'h-14';

  return (
    <div className={`flex items-center ${className}`} data-testid="mushin-logo">
      <img
        src="/mushin-logo.svg"
        alt="MUSHIN"
        className={`${h} w-auto object-contain transition-all duration-300 hover:opacity-90 opacity-85`}
        style={{
          filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.5)) drop-shadow(0 0 8px rgba(224,45,69,0.12))',
        }}
      />
    </div>
  );
}
